import script from "./TwitterMetadata.vue?vue&type=script&lang=js"
export * from "./TwitterMetadata.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__